import { render, staticRenderFns } from "./LojaPerfeitaFormControlLoadingWrap.vue?vue&type=template&id=9452db10&scoped=true&"
import script from "./LojaPerfeitaFormControlLoadingWrap.vue?vue&type=script&lang=js&"
export * from "./LojaPerfeitaFormControlLoadingWrap.vue?vue&type=script&lang=js&"
import style0 from "./LojaPerfeitaFormControlLoadingWrap.vue?vue&type=style&index=0&id=9452db10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9452db10",
  null
  
)

export default component.exports